import { ProjectBinderFolder } from '@/features/end-of-lease/ProjectBinderFolder/ProjectBinderFolder';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/lease/projects/$projectId/folders/$folderLetter/',
)({
    component: ProjectBinderFolder,
});
